import { InsightCatalogue } from '../InsightCatalogue';
import {
  FullInsightPayload,
  BaseInsightPayload,
  InsightMetric,
  validateInsightStructure,
} from '../InsightDataPayload';

export interface ProjectsStatusPayload extends FullInsightPayload {
  data: {
    type: InsightCatalogue.INSIGHTS_PROJECTS_STATUS;
    id: string;
    attributes: {
      data: Array<{
        project_status: string;
        project_count: number;
      }>;
      aggregate: {
        total_projects: InsightMetric;
      };
    };
  };
}

export const parseProjectsStatusPayload = (
  payload: BaseInsightPayload
): ProjectsStatusPayload => {
  const { data, relationships, links } = payload;

  validateInsightStructure(
    data.type,
    InsightCatalogue.INSIGHTS_PROJECTS_STATUS,
    data.attributes,
    true,
    true
  );

  // Type assertion after validation
  const typedAttributes = data.attributes as {
    data: Array<{
      project_status: string;
      project_count: number;
    }>;
    aggregate: {
      total_projects: InsightMetric;
    };
  };

  return {
    data: {
      type: InsightCatalogue.INSIGHTS_PROJECTS_STATUS,
      id: data.id,
      attributes: {
        data: typedAttributes.data,
        aggregate: {
          total_projects: typedAttributes.aggregate.total_projects,
        },
      },
    },
    ...(relationships && { relationships }),
    links,
  };
};
